<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div class="paper-outer" [ngStyle]="backgroundStyle">
	<div class="ticket">
		<!-- Top -->
		<section class="top">
			<img class="event-img" [src]="eventImage" alt="Event Image" />
			<div class="event-meta">
				<div class="title" [innerHTML]="viewModel?.dataModel?.eventName"></div>
				<div class="kvs">
					<div class="k">Event Date</div>
					<div>{{ viewModel?.dataModel?.eventDate }}</div>
					<div class="k">Event Time</div>
					<div>{{ viewModel?.dataModel?.eventTime }}</div>
					<div class="k">Venue</div>
					<div>{{ viewModel?.dataModel?.venueName }}</div>
					<div class="k">Zone</div>
					<div>{{ viewModel?.dataModel?.zone }}</div>
					<div class="k">Ticket Type</div>
					<div>{{ viewModel?.dataModel?.ticketType }}</div>
					<div class="k">NAME</div>
					<div>{{ viewModel?.dataModel?.customerName }}</div>
					<div class="k">CUSTOMER NO.</div>
					<div>{{ viewModel?.dataModel?.customerNumber }}</div>
					<div class="k">TRANSACTION NO.</div>
					<div>{{ viewModel?.dataModel?.transactionNumber }}</div>
					<div class="k" *ngIf="viewModel?.dataModel?.showLeadBooker">LEAD BOOKER</div>
					<div *ngIf="viewModel?.dataModel?.showLeadBooker">{{ viewModel?.dataModel?.leadBooker }}</div>
					<div class="k" *ngIf="viewModel?.dataModel?.showVehicleRegistrationNumber">VEHICLE REGISTRATION NUMBER</div>
					<div *ngIf="viewModel?.dataModel?.showVehicleRegistrationNumber">{{ viewModel?.dataModel?.vehicleRegistrationNumber }}</div>
					<div class="k" *ngIf="viewModel?.dataModel?.showAttendee">ATTENDEE</div>
					<div *ngIf="viewModel?.dataModel?.showAttendee">{{ viewModel?.dataModel?.attendee }}</div>
				</div>
				<div class="price">&#163;{{ viewModel?.dataModel?.eventTicketPriceType }}</div>
			</div>
			<aside class="right-rail">
				<div class="rail-inner">
					<!-- Top barcode (placeholder) -->
					<div class="barcode">
						<div class="bars" style="--bar-h: 24mm">
							<!-- Simple pattern; replace with Code-128/QR in production -->
							<span style="width: 2px"></span><span style="width: 4px"></span><span style="width: 1px"></span> <span style="width: 3px"></span><span style="width: 2px"></span><span style="width: 5px"></span> <span style="width: 2px"></span
							><span style="width: 4px"></span><span style="width: 2px"></span> <span style="width: 3px"></span><span style="width: 1px"></span><span style="width: 4px"></span> <span style="width: 2px"></span><span style="width: 3px"></span
							><span style="width: 2px"></span> <span style="width: 5px"></span><span style="width: 2px"></span><span style="width: 3px"></span>
						</div>
					</div>
					<div class="serial">{{ viewModel?.dataModel?.serialNumber }}</div>
				</div>
			</aside>
		</section>

		<hr class="hr" />

		<!-- Middle (choose one layout; here: full image) -->
		<section class="middle-section">
			<div *ngIf="isFullWidthImage" class="fullimg">
				<img [src]="displayImage" alt="ETicket image" />
			</div>

			<div *ngIf="isTextAndImage" class="split">
				<div class="copy" [innerHTML]="displayText"></div>
				<div class="half-image" [ngClass]="{ 'fade-l': shouldFadeImage, nofade: !shouldFadeImage }">
					<img [src]="displayImage" alt="ETicket image" />
				</div>
			</div>

			<div *ngIf="isImageAndText" class="split">
				<div class="half-image" [ngClass]="{ 'fade-r': shouldFadeImage, nofade: !shouldFadeImage }">
					<img [src]="displayImage" alt="ETicket image" />
				</div>
				<div class="copy" [innerHTML]="displayText"></div>
			</div>

			<div *ngIf="isFullWidthText" class="fulltext">
				<div [innerHTML]="displayText"></div>
			</div>
		</section>

		<hr class="hr" />

		<!-- Bottom -->
		<section class="bottom">
			<div class="tnc">
				<h4>Terms And Conditions For E&ndash;Tickets</h4>
				<p>
					{{ viewModel?.dataModel?.paragraph1Part1 }} <em>{{ viewModel?.dataModel?.paragraph1TermsAndConditionsLink }}</em
					>{{ viewModel?.dataModel?.paragraph1Part2 }}
				</p>
				<ol>
					<li>{{ viewModel?.dataModel?.paragraph2Part1 }}</li>
					<li>{{ viewModel?.dataModel?.paragraph2Part2 }}</li>
					<li>{{ viewModel?.dataModel?.paragraph2Part3 }}</li>
					<li>{{ viewModel?.dataModel?.paragraph2Part4 }}</li>
					<li>{{ viewModel?.dataModel?.paragraph2Part5 }}</li>
					<li>{{ viewModel?.dataModel?.paragraph2Part6 }}</li>
					<li>{{ viewModel?.dataModel?.paragraph2Part7 }}</li>
				</ol>
				<p class="stamp">{{ viewModel?.dataModel?.barcodeInvalidWarning }}</p>
				<p class="stamp">{{ viewModel?.dataModel?.protectTicketMessage }}</p>
				<p class="stamp">{{ viewModel?.dataModel?.unauthorisedDuplicationWarning }}</p>
			</div>
			<div>
				<div class="rail-inner" style="border: 1px solid #e5e7eb; border-radius: 6px; padding: 3mm">
					<!-- Bottom barcode (placeholder) -->
					<div class="barcode">
						<div class="bars" style="--bar-h: 24mm">
							<span style="width: 2px"></span><span style="width: 4px"></span><span style="width: 1px"></span> <span style="width: 3px"></span><span style="width: 2px"></span><span style="width: 5px"></span> <span style="width: 2px"></span
							><span style="width: 4px"></span><span style="width: 2px"></span> <span style="width: 3px"></span><span style="width: 1px"></span><span style="width: 4px"></span> <span style="width: 2px"></span><span style="width: 3px"></span
							><span style="width: 2px"></span> <span style="width: 5px"></span><span style="width: 2px"></span><span style="width: 3px"></span>
						</div>
					</div>
					<div class="serial">{{ viewModel?.dataModel?.orderTicketSerialNumber }}</div>
				</div>
				<div class="support support-wrap" style="margin-top: 4mm">
					<div class="label">For Queries</div>
					<div><span class="label">Phone:</span>{{ viewModel?.dataModel?.queriesPhoneNumber }}</div>
					<div><span class="label">Email:</span>{{ viewModel?.dataModel?.queriesEmail }}</div>
				</div>
			</div>
		</section>

		<div style="margin-top: auto; text-align: center; font-size: 3.2mm; color: #475569">
			{{ viewModel?.dataModel?.footerMessage }}<strong>{{ viewModel?.dataModel?.footerStartSelling }}</strong
			><br />
			{{ viewModel?.dataModel?.footerLink }}
		</div>
	</div>
</div>
